// extracted by mini-css-extract-plugin
module.exports = {"error":"ValidationError_error__cNfVg"};